import 'core-js/stable';
import { ResizeObserver } from '@juggle/resize-observer';
import 'regenerator-runtime/runtime';

if (!window.ResizeObserver) {
    window.ResizeObserver = ResizeObserver;
}
